import { IApplicationState } from '../../types/redux';
import { getExperimentGroup } from '../getExperimentGroup';
import { NEWBUILDING_ONBOARDING_MAINPAGE } from '../../constants/experiments';

export function isNewbuildingOnboardingExperimentEnabled(state: IApplicationState) {
  const regionId = state.userGeo.userGeo;
  const isMskOrMimo = [1, 4593].includes(regionId);
  const inExperiment = getExperimentGroup(state.abUseExperiments, NEWBUILDING_ONBOARDING_MAINPAGE) === 'enabled';

  return isMskOrMimo && inExperiment;
}
